<script setup>
import { ref, computed, onMounted, watch, onBeforeUnmount } from 'vue'
import { Chart, registerables } from 'chart.js'
import { getFontSize, numberFormatter, calculateYAxisMax } from '@/js/customChart.js'
import MonthlyRevGMFCST from './MonthlyRevGMFCST.vue';

Chart.register(...registerables)

// props
const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  data: {
    type: Object,
    default: () => ({})
  },
  additionalData: {
    type: Object,
  },
  options: {
    type: Object,
    default: () => ({})
  },
  width: {
    type: Number,
    default: 600
  },
  height: {
    type: Number,
    default: 600
  },
  type:{
    type:String,
  }
})

// data - ref
const MyChart = ref(null)
let chartInstance= null;
// computed
// doughnut chart center text
const chartPlugins = computed(() => {
  const plugins = []
  const dataLabel = {
    id: 'dataLabel',
    afterDatasetDraw(chart, args, pluginOptions) {
      const { ctx } = chart;
      const meta = args.meta;
      meta.data.forEach((data, index) => {
        const FCSTName = ["Rev. FCST", "GM FCST", "Total Rev. FCST", "Total GM FCST"]
        const FCST = [ ...FCSTName, ...FCSTName.map(name => `${name}-full`)]
        const isMonthly = !FCST.includes(props.title)
        const axis = {
          x: 0,
          y: 0
        }
        if (props.options.indexAxis === 'x') {
          axis.x = data.x
          axis.y = data.y
          if (chart.data.datasets[0].data[index] < 0) {
            //props.additionalData?.rawData[index].y
            axis.y = data.y - data.height
          }
        } else {
          axis.x = data.x
          if (chart.data.datasets[0].data[index] < 0) {
            axis.x = data.x + data.width
          }
          axis.y = data.y
        }
        let value
        // if (isMonthly) {
          value = `${numberFormatter(props.additionalData?.realData[index])}억`
        // } else {
        //   value = `${numberFormatter(chart.data.datasets[0].data[index])}억`
        // }
        const unit = FCST.includes(props.title) ? '%' : '억'
        const value2 = `(${numberFormatter(props.additionalData?.dataPer[index])}${unit})`
        ctx.save()
        ctx.textAlign = 'center';
        if (props.options.indexAxis === 'x') {
          ctx.textBaseline = 'bottom'
        } else {
          ctx.textAlign = 'start';
          ctx.textBaseline = 'top'
        }

        const fontSizeTitle = getFontSize({contentWidth: chart.canvas.width, contentHeight: props.height}, {}, isMonthly ? 3 : 6)
        const fontSizeSubText = getFontSize({contentWidth: chart.canvas.width, contentHeight: props.height}, {}, isMonthly ? 2.5 : 4)
        const offsetText = getFontSize({contentWidth: chart.canvas.width, contentHeight: props.height}, {}, isMonthly ? 2 : 3)
        const lineHeight = getFontSize({contentWidth: chart.canvas.width, contentHeight: props.height}, {}, isMonthly ? 2.5 : 5) * 1.2
        // ctx.font = `${fontSizeTitle}px suit-m`;
        // if (props.options.indexAxis === 'x') {

        //   ctx.fillText(value, axis.x, axis.y - fontSizeSubText);

          
        // } else {
        //   ctx.textBaseline = 'bottom'

        //   ctx.fillText(value, axis.x, axis.y);
         
        //   //ctx.fillText(value, axis.x, axis.y);
        // }
        
        // ctx.font = `${fontSizeSubText}px suit-m`;
        // if (props.options.indexAxis === 'x') {
        //   ctx.fillText(value2, axis.x, axis.y);
        // } else {
        //   ctx.fillText(value2, axis.x, axis.y + lineHeight);
        // }
        ctx.font = `${fontSizeTitle}px suit-m`;

      // value 텍스트 그리기
      const textMetricsValue = ctx.measureText(value);
      let xValue = axis.x;
      let yValue = props.options.indexAxis === 'x' ? axis.y - fontSizeSubText : axis.y;

      // x축 레이블이 캔버스 좌우 경계를 넘지 않도록 조정
      if (props.options.indexAxis === 'x') {
        if (xValue - textMetricsValue.width / 2 < 0) {
          xValue = textMetricsValue.width / 2;
        } else if (xValue + textMetricsValue.width / 2 > chart.canvas.width) {
          xValue = chart.canvas.width - textMetricsValue.width / 2;
        }
      } else { // y축 레이블이 캔버스 좌우 경계를 넘지 않도록 조정 (textAlign: 'start'이므로 오른쪽 경계만 확인)
        if (xValue + textMetricsValue.width > chart.canvas.width) {
          xValue = chart.canvas.width - textMetricsValue.width;
        }
      }
      ctx.fillText(value, xValue, yValue);

      ctx.font = `${fontSizeSubText}px suit-m`;
      let xValue2 = axis.x;
      let yValue2 = props.options.indexAxis === 'x' ? axis.y : axis.y + lineHeight;
      const textMetricsValue2 = ctx.measureText(value2);

      // x축 서브 텍스트가 캔버스 좌우 경계를 넘지 않도록 조정
      if (props.options.indexAxis === 'x') {
        if (xValue2 - textMetricsValue2.width / 2 < 0) {
          xValue2 = textMetricsValue2.width / 2;
        } else if (xValue2 + textMetricsValue2.width / 2 > chart.canvas.width) {
          xValue2 = chart.canvas.width - textMetricsValue2.width / 2;
        }
      } else { // y축 서브 텍스트가 캔버스 좌우 경계를 넘지 않도록 조정 (textAlign: 'start'이므로 오른쪽 경계만 확인)
        if (xValue2 + textMetricsValue2.width > chart.canvas.width) {
          xValue2 = chart.canvas.width - textMetricsValue2.width;
        }
      }
      ctx.fillText(value2, xValue2, yValue2);

        ctx.restore()
      })
    },
  }

  const pipelineStatus = {
    id: 'pipelineStatus',
    afterDatasetDraw(chart, args, pluginOptions) {
      const { ctx } = chart;
      const meta = args.meta;
      meta.data.forEach((data, index) => {
        const width = data.width || 0
        let x = data.x - (width / 2)
        let y = data.y
        const value = `${numberFormatter(props.additionalData.values[index])}억`
         // x와 y 값이 canvas 경계를 넘지 않도록 제한
        // x와 y 값이 canvas 경계를 넘지 않도록 제한
        x = Math.max(0, Math.min(x, chart.canvas.width));
        y = Math.max(0, Math.min(y, chart.canvas.height));
        ctx.save()
        ctx.textBaseline = 'middle'
        ctx.textAlign = 'center';
        ctx.font = `${getFontSize({contentWidth: chart.canvas.width, contentHeight: props.height}, {}, 6)}px suit-m`;
        
        ctx.fillText(value, x, y);

        ctx.restore()
      })
    },
  }

 const customTooltipPlugin = {
    id: 'customTooltipPlugin',
    beforeRender: function(chart) {  // beforeRender 또는 다른 훅에서 설정
        const tooltip = chart.options.plugins.tooltip;
        // 툴팁의 콜백을 설정하여 값을 변경
        tooltip.callbacks = {
            label: function(context,index) {
                let label =[]
                if(!props.title.includes('Monthly Rev. & GM FCST')){
                  label.push(`${props.additionalData?.realData[context.dataIndex]}억`) 
                  label.push(`${props.additionalData?.dataPer[context.dataIndex]} %`);
                }else{
                  label += `${props.additionalData?.realData[context.dataIndex]}억
                  ${props.additionalData?.dataPer[context.dataIndex]} %`;
                }
                return label
            }
        };
    }
};

const custompipelineStatusTooltipPlugin = {
  id: 'customTooltipPlugin',
  beforeTooltipDraw: function(chart, args, options) {
    // const tooltip = chart.options.plugins.tooltip;
    const tooltip = args.tooltip;
    if(tooltip.dataPoints[0].label == 'Quota'){
      tooltip.opacity = 0
    }
  }
};

  const pipelineStatusRatio = {
    id: 'pipelineStatusRatio',
    afterDatasetDraw(chart, args, pluginOptions) {
      const { ctx } = chart;
      const meta = args.meta;
      meta.data.forEach((data, index) => {
        
        if (index > 1) return
        const x = data.x
        const y = data.y - (data.height / 2)
        const value = `${props.additionalData.ratio[index]}X`
        ctx.save()
        ctx.textBaseline = 'bottom'
        ctx.textAlign = 'end';
        ctx.fillStyle = getFontColor(props.additionalData.ratio[index], 1.5, 2.5)
        ctx.font = `${getFontSize({contentWidth: chart.canvas.width, contentHeight: props.height}, {}, 4)}px suit-m`;
        ctx.fillText(value, x, y);
        ctx.restore()
      })
    },
  }

  const MonthlyRevGMFCST = {
    id: 'MonthlyRevGMFCST',
    afterDatasetDraw(chart, args, pluginOptions) {
      const { ctx } = chart;
        const meta = args.meta;
        meta.data.forEach((data, index) => {
              const FCSTName = ["Rev. FCST", "GM FCST", "Total Rev. FCST", "Total GM FCST"]
              const FCST = [ ...FCSTName, ...FCSTName.map(name => `${name}-full`)]
              const isMonthly = !FCST.includes(props.title)
        const axis = {
          x: 0,
          y: 0
              }
        if (props.options.indexAxis === 'x') {
                axis.x = data.x
                axis.y = data.y
          if (chart.data.datasets[0].data[index] < 0) {
                  axis.y = data.y - data.height
          }
        } else {
                axis.x = data.x - (data.width / 2)
          if (chart.data.datasets[0].data[index] < 0) {
                  axis.x = data.x + data.width
          }
                axis.y = data.y
        }
        const value =`${numberFormatter(props.additionalData?.rawData[index])}억`
        const unit = FCST.includes(props.title) ? '%' : '억'
        const value2 = `(${numberFormatter(props.additionalData?.dataPer[index])}${unit})`
        ctx.save()
        ctx.textAlign = 'center';
        if (props.options.indexAxis === 'x') {
          ctx.textBaseline = 'bottom'
        } else {
          ctx.textAlign = 'start';
          ctx.textBaseline = 'top'
        }
        const fontSizeTitle = getFontSize({contentWidth: chart.canvas.height, contentHeight: props.height}, {}, 6)
        const fontSizeSubText = getFontSize({contentWidth: chart.canvas.height, contentHeight: props.height}, {}, 6)
        const offsetText = getFontSize({contentWidth: chart.canvas.width, contentHeight: props.height}, {}, isMonthly ? 2 : 3)
        const lineHeight = getFontSize({contentWidth: chart.canvas.width, contentHeight: props.height}, {}, isMonthly ? 2.5 : 5) * 1.2
        const textWidthValue = ctx.measureText(value).width+ctx.measureText(value2).width;
        let textXValue;
        const textWidthValue2 = ctx.measureText(value2).width;
        let textXValue2;
        ctx.font = `italic ${fontSizeTitle}px suit-m`;
        if (props.options.indexAxis === 'x') {
          ctx.fillText(value, axis.x, axis.y - fontSizeSubText);
        } else {
          if (textWidthValue > data.width) {
            ctx.textAlign = 'start';
            textXValue = axis.x + data.width;
          } else {
            ctx.textAlign = 'center';
            textXValue =  data.width / 2;
          }
          ctx.fillText(value, textXValue, axis.y - (fontSizeTitle / 2));
        }
        ctx.font = `italic ${fontSizeSubText}px suit-m`;
        if (props.options.indexAxis === 'x') {
          ctx.textAlign = 'center';
          ctx.fillText(value2, axis.x, axis.y);
        } else {
          if (textWidthValue > data.width) {
            ctx.textAlign = 'start';
            textXValue2 = axis.x + data.width + textWidthValue2; 
          } else {
            ctx.textAlign = 'center';
            textXValue2 =  axis.x +offsetText

          }
          ctx.fillText(value2, textXValue2, axis.y - (fontSizeTitle / 2));
        }
       
        ctx.restore()
      })
    },
  }

  if (props.title.includes('Pipeline Status')) {
    plugins.push(pipelineStatus)
    plugins.push(pipelineStatusRatio)
    plugins.push(custompipelineStatusTooltipPlugin)
  } else if (props.title.includes('Monthly Rev. & GM FCST')){
    plugins.push(MonthlyRevGMFCST)
    // plugins.push(customTooltipPlugin)
  } else {
    plugins.push(dataLabel)
    plugins.push(customTooltipPlugin)
  }
  return plugins
})

// watch
watch([() => props.options,() => props.data], (newValue, oldValue) => {
  if (newValue) {
    initChart()
  }
})


// lifecycle
onMounted(() => {
  initChart()
})

onBeforeUnmount(() => {
  if(chartInstance){
    chartInstance.destroy();
    chartInstance = null;
  }
  // Chart.getChart(props.title)?.destroy()
})

function generateCustomYAxisTicks(rawData,stepSize) {
  if(!rawData){
    return
  }
  return function(value) {
    const index = Math.floor(value / stepSize);  // stepSize에 따라 인덱스 계산
    return `${rawData?.[index] || 0}억`;  // rawData에서 가져온 값에 '억' 단위 붙이기
  };
}


function calculateYScale(data, numIntervals) {
    const minValue = Math.min(...data.datasets[0].data);
    const maxValue = Math.max(...data.datasets[0].data);
    const interval = (maxValue - minValue) / numIntervals;

    let yScale = [];
    for (let i = 0; i <= numIntervals; i++) {
        yScale.push(minValue + i * interval);
    }

    return yScale;
}

function pipelineStatusMax(dataList){
  const value1 = dataList[0][1];
  const value2 = dataList[4][1];

  if (value1 > value2) {
    return value1;
  } else {
    return value2;
  }
}



// methods
function initChart() {
  if (MyChart.value) {
    if(chartInstance){
      chartInstance.destroy();
    }
  }
 
    

  // 데이터 가져오기
  const datas = props.data?.datasets?.[0]?.data;

  if (!datas) {
    return;  // 데이터가 없으면 초기화 종료
  }
  const sacles = calculateYScale(props.data,4)
  const {max,stepSize} = calculateYAxisMax(datas);
  const scales = props.type !== 'vertical' ? 'x' : 'y'
  const maxValue = props.title.includes('Pipeline Status') ? Math.ceil(pipelineStatusMax(datas)) : max
  const options = {
    ...props.options,  // 기존의 옵션을 유지하면서 추가
    scales: {
      [scales]: {
        beginAtZero: true,
        ticks: {
          callback: function(value,index) {
           
            return `${value}억`; // rawData에서 가져온 값에 '억' 단위 붙이기
          },
          // min: Math.max(1e-10, Math.min(...sacles)), // y축의 최소값 설정
          // max: Math.max(...sacles), // y축의 최대값 설정
          // stepSize: (Math.max(...sacles) - Math.min(...sacles)) / (sacles.length - 1)
        },
        max: maxValue ,  // 계산된 최대값 추가
       
      }
    }
  }


  chartInstance = new Chart(MyChart.value, {
    type: 'bar',
    plugins: chartPlugins.value,
    data: props.data,
    options
  })
}

function getFontColor(value, min, max) {
  if (isNaN(value)) return
  const condition = {
    red: value < min,
    orange: min <= value && value < max,
    green: max <= value
  }
  const [ color ] = Object.entries(condition).find(item => item[1])
  return color
}
</script>

<template>
  <article class="canvas-wrap" :style="{ width: `${width}px`, height: `${height}px` }">
    <canvas :id="title" ref="MyChart" />
  </article>
</template>

<style scoped>
.canvas-wrap {
  display: flex;
  justify-content: center;
  align-items: center
}
.my-custom-tooltip {
        display: none;
    }
</style>
